import React from 'react';
import { NavLink } from 'react-router-dom';
import style from "./Modal.module.css"
// import nft from './nft.jpg';

const Modal = ({ open, onClose }) => {
  if (!open) return null;
  return (
    <div onClick={onClose} className={style.overlay}>
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className={style.modalContainer}
      >
        <div>
          <h1>Performance</h1>
          <div>
            <img src="https://nzxt.com/assets/cms/34299/1620400903-modern-warfare-alt.png?auto=format&dpr=1.5&fit=clamp&h=127&w=127" alt="" />
            <img src="" alt="" />
            <img src="" alt="" />
            <img src="" alt="" />
          </div>
        </div>
        <div className={style.modalRight}>
          <p className={style.closeBtn} onClick={onClose}>
            X
          </p>
          <div className={style.content}>
            <p>Do you want a</p>
            <h1>$20 CREDIT</h1>
            <p>for your first tade?</p>
          </div>
          <div className={style.btnContainer}>
            <button className={style.btnPrimary}>
              <span className={style.bold}>YES</span>, I love NFT's
            </button>
            <button className={style.btnOutline}>
              <span className={style.bold}>NO</span>, thanks
            </button>
            <NavLink className={style.confirm} to="/Configurator">Confirm</NavLink>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;